import { render, staticRenderFns } from "./SysCategoryList.vue?vue&type=template&id=0963aeb8&scoped=true"
import script from "./SysCategoryList.vue?vue&type=script&lang=js"
export * from "./SysCategoryList.vue?vue&type=script&lang=js"
import style0 from "./SysCategoryList.vue?vue&type=style&index=0&id=0963aeb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963aeb8",
  null
  
)

export default component.exports